import {useEffect, useState} from "react";
import {Alert, Button, Col, Divider, Form, message, Modal, Radio, Row, Space, Spin, Upload} from "antd";
import {CustomerWrapperDto} from "../../dto/CustomerWrapperDto";
import {
    ALLOWED_ALL_DOCUMENT_TYPE_EXTENSION,
    ALLOWED_ALL_TYPES_TEXT,
    ALLOWED_DOCUMENT_TYPES,
    ALLOWED_IMAGE_TYPE_EXTENSION,
    ALLOWED_IMAGE_TYPES,
    ALLOWED_IMAGE_TYPES_TEXT,
    DOC_CODE_ADDITIONAL_SUPPORTING_DOC,
    DOC_CODE_BILLING_PROOF,
    DOC_CODE_FACT_FORM,
    DOC_CODE_SECONDARY_BANK_DOC,
    DOC_CODE_W9_FORM,
    DOCUMENT_TYPES,
    IDENTIFICATION_SOURCE_ID,
    NOT_AVAILABLE,
    PREVIEW_DOC_TYPES,
    RADIO_BUTTON_VALUES
} from "../../util/Constants";
import documentService from "../../service/documentService";
import {
    MSG_ALLOWED_ALL_DOCUMENT_TYPES_ERROR,
    MSG_ALLOWED_IMAGE_TYPES_ERROR,
    MSG_FAILED_TO_DELETE_DOCUMENTS_ERROR,
    MSG_FAILED_TO_FETCH_AGREEMENTS_ERROR,
    MSG_FAILED_TO_PREVIEW_DOCUMENTS_ERROR,
    MSG_FAILED_TO_UPLOAD_DOCUMENTS_ERROR
} from "../../util/Messages";
import ErrorHandler from "../../util/ErrorHandler";
import {UploadedDocumentDetailDto} from "../../dto/UploadedDocumentDetailDto";
import {PageStep} from "../../enums/PageStep";
import {CustomerDto} from "../../dto/CustomerDto";
import {DefaultDocumentDto} from "../../dto/DefaultDocumentDto";
import {DownloadOutlined, PlusOutlined} from "@ant-design/icons";
import PreviewModalComp from "../common/preview/PreviewModalComp";
import {step_6_inactive_img} from '../../../AppImageConst';
import {toNumber} from "lodash";

interface AttachmentAndSupportingDetailPropData {
    savedCusDetailFromPreviousStep: CustomerWrapperDto
    getStepperFilledData: (data: CustomerWrapperDto) => void,
    switchStep?: () => void,
    isFromSummaryView: boolean
}


const AttachmentAndSupportingDetail = (props: AttachmentAndSupportingDetailPropData) => {
    const uploadFileSize: number | undefined = process.env.UPLOAD_FILE_SIZE ? toNumber(process.env.UPLOAD_FILE_SIZE) : 4;
    const [form] = Form.useForm();
    const [identificationSourceId, setIdentificationSourceId] = useState<number>()
    const [secondaryBankStatus, setSecondaryBankStatus] = useState<boolean>()
    const [utilityBillUploadStatus, setUtilityBillUploadStatus] = useState<boolean>()
    const [greenCardHolderStatus, setGreenCardHolderStatus] = useState<boolean>()
    const [billingProofStatus, setBillingProofStatus] = useState<boolean>(true)
    const [isSpinnerLoading, setSpinnerLoading] = useState<boolean>(false)
    const [nicFrontUploadedList, setNicFrontUploadedList] = useState<DefaultDocumentDto[]>()
    const [nicRearUploadedList, setNicRearUploadedList] = useState<DefaultDocumentDto[]>()
    const [passportUploadedList, setPassportUploadedList] = useState<DefaultDocumentDto[]>()
    const [dLicenseFrontUploadedList, setDLicenseFrontUploadedList] = useState<DefaultDocumentDto[]>()
    const [utilityBillUploadedList, setUtilityBillUploadedList] = useState<DefaultDocumentDto[]>()
    const [primaryBankUploadedList, setPrimaryBankUploadedList] = useState<DefaultDocumentDto[]>()
    const [secondaryBankUploadedList, setSecondaryBankUploadedList] = useState<DefaultDocumentDto[]>()
    const [w9UploadedList, setW9UploadedList] = useState<DefaultDocumentDto[]>()
    const [fatcaUploadedList, setFatcaUploadedList] = useState<DefaultDocumentDto[]>()
    const [profilePicUploadedList, setProfilePicUploadedList] = useState<DefaultDocumentDto[]>()
    const [additionalUploadedList, setAdditionalUploadedList] = useState<DefaultDocumentDto[]>()
    const [previewOpen, setPreviewOpen] = useState(false);
    const [docURL, setDocURL] = useState('');
    const [docType, setDocType] = useState<PREVIEW_DOC_TYPES>(PREVIEW_DOC_TYPES.IMAGE);
    const [previewTitle, setPreviewTitle] = useState('');
    const [isDocumentUploaded, setDocumentUploaded] = useState<boolean>(false);

    let customerMstDto = props.savedCusDetailFromPreviousStep.customerMstDto;
    useEffect(() => {
        // let utilityBillStatus = undefined != customerMstDto.addressList ? customerMstDto.addressList?.length > 1 : false;
        let identificationSourceIdLocal = customerMstDto.identificationSource?.id;
        // let utilityBillStatus = undefined != customerMstDto.addressList ? !customerMstDto.addressList[0].permanentAddressIdenticalToNicDl : false;
        let utilityBillStatus;
        if (IDENTIFICATION_SOURCE_ID.PP === identificationSourceIdLocal){
            utilityBillStatus = true
        }else if (undefined != customerMstDto.addressList){
            utilityBillStatus = !customerMstDto.addressList[0].permanentAddressIdenticalToNicDl;
        }else {
            utilityBillStatus = false;
        }
        window.scrollTo(0, 0)
        setIdentificationSourceId(identificationSourceIdLocal)
        setSecondaryBankStatus(undefined != customerMstDto.bankDetailList ? customerMstDto.bankDetailList?.length > 1 : false)
        setUtilityBillUploadStatus(utilityBillStatus)
        setGreenCardHolderStatus(RADIO_BUTTON_VALUES.YES === customerMstDto.greenCardHolderStatus)

        if (null != customerMstDto.isBillingProofUnderYourName) {
            loadUploadedDocuments(customerMstDto.id, ["NIC", "DL", "PP", "BP", "FACT", "PBCL", "SBCL", "W9", "PROPIC", "ASD"], true, identificationSourceIdLocal as number)
            setBillingProofStatus(utilityBillStatus && RADIO_BUTTON_VALUES.NO === customerMstDto.isBillingProofUnderYourName)
            form.setFieldsValue({
                billingProofStatus: NOT_AVAILABLE != customerMstDto.isBillingProofUnderYourName ? customerMstDto.isBillingProofUnderYourName : RADIO_BUTTON_VALUES.YES,
                billingProofType: NOT_AVAILABLE != customerMstDto.billingProofType ? customerMstDto.billingProofType : RADIO_BUTTON_VALUES.UTILITY_BILL,
            })

        } else {
            setBillingProofStatus(false)
            form.setFieldsValue({
                billingProofStatus: RADIO_BUTTON_VALUES.YES,
                billingProofType: RADIO_BUTTON_VALUES.UTILITY_BILL,
            })
        }
    }, [])

    const loadUploadedDocuments = (jobNo: number | undefined, identityDocumentTypeCodeList: string[], init: boolean, isd: number) => {
        if (jobNo) {
            setSpinnerLoading(true)
            documentService.getUploadDocumentListByType(jobNo, identityDocumentTypeCodeList).then(res => {
                if (res.data !== null) {
                    setUploadedDocumentList(res.data.results, init, isd)
                } else {
                    setSpinnerLoading(false)
                    message.error(MSG_FAILED_TO_FETCH_AGREEMENTS_ERROR).then();
                }
            }, (reason) => {
                setSpinnerLoading(false)
                ErrorHandler.handleError(reason);
            })
        }

    };

    const setUploadedDocumentList = (documents: any, init: boolean, isd: number) => {
        documents.forEach((document: any) => {
            let uploadDocumentDetailDto: UploadedDocumentDetailDto = document.uploadDocumentDetailDto;
            createUploadedDocuments(uploadDocumentDetailDto, document.documentTypeId, init, isd)
        })
        setSpinnerLoading(false)
    };

    const createUploadedDocuments = (uploadDocumentDetailDtoList: UploadedDocumentDetailDto, documentTypeId: number, init: boolean, isd: number) => {
        let defaultFileList;
        if (undefined != uploadDocumentDetailDtoList) {
            defaultFileList =
                [{
                    uid: uploadDocumentDetailDtoList.uploadDocumentDetailId.toString(),
                    name: uploadDocumentDetailDtoList.originalDocumentName,
                    thumbUrl: uploadDocumentDetailDtoList.thumbB64,
                    url: uploadDocumentDetailDtoList.thumbDocumentPath
                }]
        } else {
            defaultFileList = undefined;
        }

        if (documentTypeId == DOCUMENT_TYPES.NICF) {
            setNicFrontUploadedList(defaultFileList)
            form.setFieldsValue({frontNicUpload: defaultFileList})
        } else if (documentTypeId == DOCUMENT_TYPES.NICR) {
            setNicRearUploadedList(defaultFileList)
            form.setFieldsValue({rearNicUpload: defaultFileList})
        } else if (documentTypeId == DOCUMENT_TYPES.DLF) {
            setDLicenseFrontUploadedList(defaultFileList)
            form.setFieldsValue({frontDLicenseUpload: defaultFileList})
        } else if (documentTypeId == DOCUMENT_TYPES.PASSPORT) {
            setPassportUploadedList(defaultFileList)
            form.setFieldsValue({passportUpload: defaultFileList})
        } else if (documentTypeId == DOCUMENT_TYPES.BP) {
            setUtilityBillUploadedList(defaultFileList)
            form.setFieldsValue({uploadUtilityBill: defaultFileList})
            if (init) {
                // checkAndRemove(defaultFileList, (undefined != customerMstDto.addressList ? customerMstDto.addressList?.length < 2: false), DOC_CODE_BILLING_PROOF)
                let utilityBillStatus = getBillStatus(customerMstDto, isd);
                checkAndRemove(defaultFileList, utilityBillStatus , DOC_CODE_BILLING_PROOF)
            }
        } else if (documentTypeId == DOCUMENT_TYPES.PBCL) {
            form.setFieldsValue({primaryBankUpload: defaultFileList})
            setPrimaryBankUploadedList(defaultFileList)
        } else if (documentTypeId == DOCUMENT_TYPES.SBCL) {
            form.setFieldsValue({secondaryBankUpload: defaultFileList})
            setSecondaryBankUploadedList(defaultFileList)
            if (init) {
                checkAndRemove(defaultFileList, (undefined != customerMstDto.bankDetailList ? customerMstDto.bankDetailList?.length < 2 : false), DOC_CODE_SECONDARY_BANK_DOC)
            }
        } else if (documentTypeId == DOCUMENT_TYPES.W9) {
            form.setFieldsValue({w9Upload: defaultFileList})
            setW9UploadedList(defaultFileList)
            if (init) {
                checkAndRemove(defaultFileList, RADIO_BUTTON_VALUES.NO === customerMstDto.greenCardHolderStatus, DOC_CODE_W9_FORM)
            }
        } else if (documentTypeId == DOCUMENT_TYPES.FATCA_FORM) {
            form.setFieldsValue({fatcaUpload: defaultFileList})
            setFatcaUploadedList(defaultFileList)
            if (init) {
                checkAndRemove(defaultFileList, RADIO_BUTTON_VALUES.NO === customerMstDto.greenCardHolderStatus, DOC_CODE_FACT_FORM)
            }
        } else if (documentTypeId == DOCUMENT_TYPES.PROPIC) {
            form.setFieldsValue({uploadProfilePic: defaultFileList})
            setProfilePicUploadedList(defaultFileList)
        } else if (documentTypeId == DOCUMENT_TYPES.ASD) {
            form.setFieldsValue({uploadAdditional: defaultFileList})
            setAdditionalUploadedList(defaultFileList)
            if (init) {
                let utilityBillStatus = getBillStatus(customerMstDto, isd);
                checkAndRemove(defaultFileList, utilityBillStatus, DOC_CODE_ADDITIONAL_SUPPORTING_DOC)
                const billingProofStatus = form.getFieldValue("billingProofStatus")

                if (RADIO_BUTTON_VALUES.YES === billingProofStatus){
                    checkAndRemove(defaultFileList, RADIO_BUTTON_VALUES.YES === billingProofStatus, DOC_CODE_ADDITIONAL_SUPPORTING_DOC)

                }

            }

        }
    };

    const getBillStatus = (customerMstDto: CustomerDto, isd: number) => {
        if (IDENTIFICATION_SOURCE_ID.PP === isd){
            return false
        }else if (undefined != customerMstDto.addressList){
            return customerMstDto.addressList[0].permanentAddressIdenticalToNicDl;
        }else {
            return false;
        }
    }

    const checkAndRemove = (defaultDoc: any, status: undefined | boolean, code: string) => {
        if (status && undefined != defaultDoc) {
            onRemove(code, defaultDoc[0].uid)
        }
    }

    const beforeUploadNicFront = (file: any) => {
        return validateDocument(file, DOCUMENT_TYPES.NICF, ALLOWED_IMAGE_TYPES);
    };
    const beforeUploadPassport = (file: any) => {
        return validateDocument(file, DOCUMENT_TYPES.PASSPORT, ALLOWED_IMAGE_TYPES);
    };
    const beforeUploadDrivingLicenseFront = (file: any) => {
        return validateDocument(file, DOCUMENT_TYPES.DLF, ALLOWED_IMAGE_TYPES);
    };

    const beforeUploadNicRear = (file: any) => {
        return validateDocument(file, DOCUMENT_TYPES.NICR, ALLOWED_IMAGE_TYPES);
    };

    const beforeUploadUtilityBill = (file: any) => {
        return validateDocument(file, DOCUMENT_TYPES.BP, ALLOWED_IMAGE_TYPES);
    };

    const beforeUploadPBCD = (file: any) => {
        return validateDocument(file, DOCUMENT_TYPES.PBCL, ALLOWED_IMAGE_TYPES);
    };
    const beforeUploadSBCD = (file: any) => {
        return validateDocument(file, DOCUMENT_TYPES.SBCL, ALLOWED_IMAGE_TYPES);
    };
    const beforeUploadW9 = (file: any) => {
        return validateDocument(file, DOCUMENT_TYPES.W9, ALLOWED_DOCUMENT_TYPES.concat(ALLOWED_IMAGE_TYPES));
    };
    const beforeUploadFATCA = (file: any) => {
        return validateDocument(file, DOCUMENT_TYPES.FATCA_FORM, ALLOWED_DOCUMENT_TYPES.concat(ALLOWED_IMAGE_TYPES));
    };
    const beforeUploadPP = (file: any) => {
        return validateDocument(file, DOCUMENT_TYPES.PROPIC, ALLOWED_IMAGE_TYPES);
    };
    const beforeUploadASD = (file: any) => {
        return validateDocument(file, DOCUMENT_TYPES.ASD, ALLOWED_IMAGE_TYPES);
    };

    const validateDocument = (file: any, type: DOCUMENT_TYPES, allowedDocTypes: string[]) => {
        setSpinnerLoading(true)
        let indexOf = allowedDocTypes.indexOf(file.type);
        if (indexOf < 0) {

            if (type == DOCUMENT_TYPES.FATCA_FORM || type == DOCUMENT_TYPES.W9) {
                message.error(MSG_ALLOWED_ALL_DOCUMENT_TYPES_ERROR);
            } else {
                message.error(MSG_ALLOWED_IMAGE_TYPES_ERROR);
            }
            // message.error(JSON.stringify(allowedDocTypes) === JSON.stringify(ALLOWED_IMAGE_TYPES) ? MSG_ALLOWED_IMAGE_TYPES_ERROR : MSG_ALLOWED_DOCUMENT_TYPES_ERROR);
            setSpinnerLoading(false)
            return Upload.LIST_IGNORE;
        }
        const isLt2M = file.size / 1024 / 1024 <= uploadFileSize;
        if (!isLt2M) {
            message.error(`Document must smaller than ${uploadFileSize}MB!`);
            setSpinnerLoading(false)
            return Upload.LIST_IGNORE;
        }

        const formData = new FormData();
        formData.append("files", file);

        formData.append("jobNo", JSON.stringify(customerMstDto.id));
        formData.append("documentTypeId", JSON.stringify(type));

        documentService.uploadDocument(formData).then(res => {
            if (res.data !== null) {
                let results = res.data.results;
                let uploadDocumentDetailDto: UploadedDocumentDetailDto = results.uploadDocumentDetailDtoList[0];
                createUploadedDocuments(uploadDocumentDetailDto, uploadDocumentDetailDto.documentTypeId, false, identificationSourceId as number)
                setSpinnerLoading(false)
                setDocumentUploaded(true)
            } else {
                setSpinnerLoading(false)
                message.error(MSG_FAILED_TO_UPLOAD_DOCUMENTS_ERROR).then();
            }
        }, (reason) => {
            setSpinnerLoading(false)
            ErrorHandler.handleError(reason);
        })
        return false;
    };

    const submitStep = (value: any) => {
        let customerWrapperDto = props.savedCusDetailFromPreviousStep;
        let actionStatus = null != customerMstDto.isBillingProofUnderYourName;
        if (checkChanges(customerMstDto, value) || isDocumentUploaded) {

            customerMstDto.isBillingProofUnderYourName = undefined != value.billingProofStatus ? value.billingProofStatus : "N/A";
            customerMstDto.billingProofType = undefined != value.billingProofType ? value.billingProofType : "N/A";
            customerWrapperDto.recordStatus = actionStatus ? "UPDATE" : "SAVE";
            customerWrapperDto.isFinalStep = false;
            customerWrapperDto.currentActiveStep = PageStep.STEP_ATTACHMENT_SUPPORT_DETAIL;
            customerWrapperDto.customerMstDto = customerMstDto;
            props.getStepperFilledData(customerWrapperDto);
        } else {
            if (props.switchStep) props.switchStep()
        }
    }
    const checkChanges = (prvCustomerDto: CustomerDto, curFormValues: any) => {

        if (("N/A" == prvCustomerDto.isBillingProofUnderYourName && "N/A" == prvCustomerDto.billingProofType)) {
            return false;
        } else {
            if (undefined === curFormValues.billingProofStatus && undefined === curFormValues.billingProofType) {
                return true;
            } else if (prvCustomerDto.isBillingProofUnderYourName != curFormValues.billingProofStatus) {
                return true;
            } else if (prvCustomerDto.billingProofType != curFormValues.billingProofType) {
                return true;
            }
            return false;
        }

    }

    const onPreview = async (file: any, docId: DOCUMENT_TYPES) => {
        setSpinnerLoading(true)
        documentService.viewOriginalDocument(getUidByCode(docId)).then(res => {
            if (res.data !== null) {
                setPreviewOpen(true);
                setPreviewTitle(file.name || file.url!.substring(file.url!.lastIndexOf('/') + 1));
                setDocURL(res.data.results)
                setDocType(checkDocumentContentType(res.data.results))
                setSpinnerLoading(false)
            } else {
                message.error(MSG_FAILED_TO_PREVIEW_DOCUMENTS_ERROR).then();
                setSpinnerLoading(false)
            }
        }, (reason) => {
            setSpinnerLoading(false)
            ErrorHandler.handleError(reason);
        })
        return true;

    };

    const checkDocumentContentType = (base64: string): PREVIEW_DOC_TYPES => {

        if (base64.includes("image/png") || base64.includes("image/jpeg") || base64.includes("image/jpg")) {
            return PREVIEW_DOC_TYPES.IMAGE;
        } else {
            return PREVIEW_DOC_TYPES.PDF;
        }

    };

    const configs = {
        name: 'file',
        multiple: false,
        maxCount: 1
    };
    const handleCancel = () => setPreviewOpen(false);

    const onRemove = (code: string, docId: number) => {
        if (customerMstDto && customerMstDto.id) {
            setSpinnerLoading(true)
            documentService.deleteDocument(getUidByCode(docId), customerMstDto?.id.toString(), PageStep.STEP_ATTACHMENT_SUPPORT_DETAIL).then(res => {
                if (res.data !== null) {
                    setSpinnerLoading(false)
                    loadUploadedDocuments(customerMstDto?.id, [code], false, identificationSourceId as number)
                } else {
                    setSpinnerLoading(false)
                    message.error(MSG_FAILED_TO_DELETE_DOCUMENTS_ERROR).then();
                }
            }, (reason) => {
                setSpinnerLoading(false)
                ErrorHandler.handleError(reason);
            })
        }

        return true;
    };

    const getUidByCode = (docId: number): string => {
        console.log(docId)
        switch (docId) {
            case DOCUMENT_TYPES.NICF: {
                return undefined != nicFrontUploadedList ? nicFrontUploadedList[0].uid : docId.toString();
            }
            case DOCUMENT_TYPES.NICR: {
                return undefined != nicRearUploadedList ? nicRearUploadedList[0].uid : docId.toString();
            }
            case DOCUMENT_TYPES.DLF: {
                return undefined != dLicenseFrontUploadedList ? dLicenseFrontUploadedList[0].uid : docId.toString();
            }
            case DOCUMENT_TYPES.PASSPORT: {
                return undefined != passportUploadedList ? passportUploadedList[0].uid : docId.toString();
            }
            case DOCUMENT_TYPES.BP: {
                return undefined != utilityBillUploadedList ? utilityBillUploadedList[0].uid : docId.toString();
            }
            case DOCUMENT_TYPES.FATCA_FORM: {
                return undefined != fatcaUploadedList ? fatcaUploadedList[0].uid : docId.toString();
            }
            case DOCUMENT_TYPES.PBCL: {
                return undefined != primaryBankUploadedList ? primaryBankUploadedList[0].uid : docId.toString();
            }
            case DOCUMENT_TYPES.SBCL: {
                return undefined != secondaryBankUploadedList ? secondaryBankUploadedList[0].uid : docId.toString();
            }
            case DOCUMENT_TYPES.W9: {
                return undefined != w9UploadedList ? w9UploadedList[0].uid : docId.toString();
            }
            case DOCUMENT_TYPES.PROPIC: {
                return undefined != profilePicUploadedList ? profilePicUploadedList[0].uid : docId.toString();
            }
            case DOCUMENT_TYPES.ASD: {
                return undefined != additionalUploadedList ? additionalUploadedList[0].uid : docId.toString();
            }
            default: {
                return docId.toString();
            }
        }
    };

    const onBillingProofStatusChange = (evt: Event) => {
        let value = (evt.target as HTMLInputElement).value as unknown as string;
        if (RADIO_BUTTON_VALUES.YES === value) {
            if (undefined != additionalUploadedList) {
                onRemove(DOC_CODE_ADDITIONAL_SUPPORTING_DOC, DOCUMENT_TYPES.ASD)
            }
        }
        setBillingProofStatus(RADIO_BUTTON_VALUES.NO === value)
    };
    const normFile = (e: { fileList: any; }) => {
        if (Array.isArray(e)) {
            return e;
        }
        return e && e.fileList;
    };
    const download = (val: string, docName: string) => {
        let a = document.createElement('a');
        a.href = val;
        a.download = docName;
        a.click();
    }

    return (
        <Spin spinning={isSpinnerLoading} tip="Loading" size="large">
            <div>
                <Modal
                    className={docType == PREVIEW_DOC_TYPES.PDF ? "modal-custom-bg" : "image-view-modal"}
                    open={previewOpen}
                    centered
                    title={previewTitle}
                    onCancel={handleCancel}
                    destroyOnClose={true}
                    width={docType == PREVIEW_DOC_TYPES.PDF ? 800 : 600}
                    footer={[
                        <Button type="primary" icon={<DownloadOutlined/>} style={{background: '#FF7400', height: 40}}
                                htmlType="submit" onClick={() => download(docURL, previewTitle)}>
                            Download
                        </Button>]}>
                    {/*<img alt="example" style={{width: '100%'}} src={docURL}/>*/}
                    <PreviewModalComp docURL={docURL} divHeight={'70vh'}/>
                </Modal>
                <p className='step_card_header'>
                    <div className="icon-container">
                        <img className='header-icon-img' src={step_6_inactive_img}/>
                    </div>
                    Attachments and Supporting
                </p>
                <Form
                    className='form-input attachments-upload-form'
                    layout={"vertical"}
                    initialValues={{remember: true}}
                    form={form}
                    onFinish={submitStep}
                    disabled={props.isFromSummaryView}
                >

                    <Row gutter={[32, 0]}>
                        <Col span={24}>
                            {(IDENTIFICATION_SOURCE_ID.NIC === identificationSourceId) ?
                                <Form.Item style={{marginBottom: 4}}
                                           label={
                                               <>
                                                   <h4 className='account-create-form-subheader'
                                                       style={{marginBottom: 0}}>Upload Your NIC to Verify Your
                                                       Identity</h4>
                                               </>
                                           }
                                >
                                    <Row gutter={[32, 8]}>
                                        <Col xxl={12} xl={12} lg={12} md={24} sm={24} xs={24}>
                                            <Form.Item
                                                name={"frontNicUpload"}
                                                label="Front NIC"
                                                getValueFromEvent={normFile}
                                                initialValue={nicFrontUploadedList && nicFrontUploadedList?.length > 0 ? [nicFrontUploadedList] : undefined}
                                                rules={[{
                                                    required: true,
                                                    message: 'Please upload the front image of the NIC'
                                                }]}>

                                                <Upload
                                                    {...configs}
                                                    accept={ALLOWED_IMAGE_TYPE_EXTENSION}
                                                    className='upload_comp'
                                                    listType="picture"
                                                    fileList={nicFrontUploadedList && nicFrontUploadedList?.length > 0 ? nicFrontUploadedList : undefined}
                                                    onRemove={(e: any) => onRemove("NIC", DOCUMENT_TYPES.NICF)}
                                                    onPreview={(e: any) => onPreview(e, DOCUMENT_TYPES.NICF)}
                                                    beforeUpload={beforeUploadNicFront}>
                                                    {/*<Button icon={<UploadOutlined/>}>Front image of NIC</Button>*/}
                                                    {(undefined != nicFrontUploadedList ? nicFrontUploadedList.length : [].length) < 1 &&
                                                        <Button>
                                                            <div className='upload-btn-div'>
                                                                <div className="upload-icon-div">
                                                                    <PlusOutlined
                                                                        style={{fontSize: 20, color: '#757575'}}/>
                                                                </div>
                                                                <div className="upload-btn-text-div">
                                                                        <span>
                                                                            Upload the Front Image of the NIC {ALLOWED_IMAGE_TYPES_TEXT}
                                                                        </span>
                                                                </div>
                                                            </div>
                                                        </Button>
                                                    }
                                                </Upload>

                                            </Form.Item>
                                        </Col>
                                        <Col xxl={12} xl={12} lg={12} md={24} sm={24} xs={24}>
                                            <Form.Item
                                                name={"rearNicUpload"}
                                                label="Rear NIC"
                                                getValueFromEvent={normFile}
                                                initialValue={nicRearUploadedList && nicRearUploadedList?.length > 0 ? [nicRearUploadedList] : undefined}
                                                rules={[{
                                                    required: true,
                                                    message: 'Please upload the rear image of the NIC'
                                                }]}>
                                                <Upload {...configs}
                                                        className='upload_comp'
                                                        listType="picture"
                                                        accept={ALLOWED_IMAGE_TYPE_EXTENSION}
                                                        onPreview={(e: any) => onPreview(e, DOCUMENT_TYPES.NICR)}
                                                        onRemove={(e: any) => onRemove("NIC", DOCUMENT_TYPES.NICR)}
                                                        fileList={nicRearUploadedList && nicRearUploadedList?.length > 0 ? nicRearUploadedList : undefined}
                                                        beforeUpload={beforeUploadNicRear}>
                                                    {(undefined != nicRearUploadedList ? nicRearUploadedList.length : [].length) < 1 &&

                                                        <Button>
                                                            <div className='upload-btn-div'>
                                                                <div className="upload-icon-div">
                                                                    <PlusOutlined
                                                                        style={{fontSize: 20, color: '#757575'}}/>
                                                                </div>
                                                                <div className="upload-btn-text-div">
                                                                        <span>
                                                                           Upload the Rear Image of the NIC {ALLOWED_IMAGE_TYPES_TEXT}
                                                                        </span>
                                                                </div>
                                                            </div>
                                                        </Button>
                                                    }
                                                </Upload>
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                </Form.Item>
                                : (IDENTIFICATION_SOURCE_ID.PP === identificationSourceId) ?
                                    <Form.Item style={{marginBottom: 4}}
                                               label={
                                                   <>
                                                       <h4 className='account-create-form-subheader'
                                                           style={{marginBottom: 0}}>Upload Your Passport Detail Page to
                                                           Verify Your Identity</h4>
                                                   </>
                                               }
                                    >
                                        <Row gutter={[32, 8]} className='passport-upload-row'>
                                            <Form.Item
                                                name={"passportUpload"}
                                                label="Passport"
                                                getValueFromEvent={normFile}
                                                initialValue={passportUploadedList && passportUploadedList?.length > 0 ? [passportUploadedList] : undefined}
                                                rules={[{
                                                    required: true,
                                                    message: "Please upload an image of the passport\'s detailed page"
                                                }]}>
                                                <Col xxl={12} xl={12} lg={12} md={24} sm={24} xs={24}
                                                     className='passport-upload-col'>
                                                    <Upload {...configs}
                                                            accept={ALLOWED_IMAGE_TYPE_EXTENSION}
                                                            className='upload_comp'
                                                            listType="picture"
                                                            onPreview={(e: any) => onPreview(e, DOCUMENT_TYPES.PASSPORT)}
                                                            onRemove={(e: any) => onRemove("PP", DOCUMENT_TYPES.PASSPORT)}
                                                            fileList={passportUploadedList && passportUploadedList?.length > 0 ? passportUploadedList : undefined}
                                                            beforeUpload={beforeUploadPassport}>
                                                        {(undefined != passportUploadedList ? passportUploadedList.length : [].length) < 1 &&
                                                            <Button>
                                                                <div className='upload-btn-div'>
                                                                    <div className="upload-icon-div">
                                                                        <PlusOutlined
                                                                            style={{fontSize: 20, color: '#757575'}}/>
                                                                    </div>
                                                                    <div className="upload-btn-text-div">
                                                                    <span>
                                                                      Upload an Image of the Passport’s Detailed Page {ALLOWED_IMAGE_TYPES_TEXT}
                                                                    </span>
                                                                    </div>
                                                                </div>
                                                            </Button>
                                                        }
                                                    </Upload>
                                                </Col>
                                            </Form.Item>
                                        </Row>
                                    </Form.Item>
                                    : (IDENTIFICATION_SOURCE_ID.DD === identificationSourceId) ?
                                        <Form.Item
                                            label={
                                                <>
                                                    <h4 className='account-create-form-subheader'
                                                        style={{marginBottom: 0}}>Upload Your Driving License to Verify
                                                        Your Identity</h4>
                                                </>
                                            }
                                        >
                                            <Row gutter={[32, 8]}>
                                                <Col xxl={12} xl={12} lg={12} md={24} sm={24} xs={24}>
                                                    <Form.Item
                                                        name={"frontDLicenseUpload"}
                                                        label="Driving License"
                                                        getValueFromEvent={normFile}
                                                        initialValue={dLicenseFrontUploadedList && dLicenseFrontUploadedList?.length > 0 ? [dLicenseFrontUploadedList] : undefined}
                                                        rules={[{
                                                            required: true,
                                                            message: 'Please upload the image of your driving license'
                                                        }]}
                                                        style={{marginBottom: 0}}>

                                                        <Upload {...configs}
                                                                className='upload_comp'
                                                                accept={ALLOWED_IMAGE_TYPE_EXTENSION}
                                                                listType="picture"
                                                                onPreview={(e: any) => onPreview(e, DOCUMENT_TYPES.DLF)}
                                                                onRemove={(e: any) => onRemove("DL", DOCUMENT_TYPES.DLF)}
                                                                fileList={dLicenseFrontUploadedList && dLicenseFrontUploadedList?.length > 0 ? dLicenseFrontUploadedList : undefined}
                                                                beforeUpload={beforeUploadDrivingLicenseFront}>
                                                            {(undefined != dLicenseFrontUploadedList ? dLicenseFrontUploadedList.length : [].length) < 1 &&
                                                                <Button>
                                                                    <div className='upload-btn-div'>
                                                                        <div className="upload-icon-div">
                                                                            <PlusOutlined
                                                                                style={{
                                                                                    fontSize: 20,
                                                                                    color: '#757575'
                                                                                }}/>
                                                                        </div>
                                                                        <div className="upload-btn-text-div">
                                                                <span>
                                                                  Upload an Image of the Driving License {ALLOWED_IMAGE_TYPES_TEXT}
                                                                </span>
                                                                        </div>
                                                                    </div>
                                                                </Button>
                                                            }
                                                        </Upload>
                                                    </Form.Item>
                                                </Col>

                                            </Row>
                                        </Form.Item>
                                        : <></>
                            }
                        </Col>


                        {utilityBillUploadStatus ?
                            <Col xxl={12} xl={12} lg={12} md={24} sm={24} xs={24}>
                                <Form.Item className='upload-form-item-lbl'
                                           label={
                                               <>
                                                   <h4 className='account-create-form-subheader'
                                                       style={{marginBottom: 0}}>Upload Your Billing Proof</h4>
                                               </>
                                           }
                                    // name={"billingProofStatus"}
                                           rules={!props.isFromSummaryView ?
                                               [{
                                                   required: true,
                                                   message: 'Please select billing proof status'
                                               }] : []}>
                                </Form.Item>
                                <Form.Item className='upload-form-item-radio-btn'
                                           label="Is the Billing Proof Under Your Name?"
                                           name={"billingProofStatus"}
                                           rules={!props.isFromSummaryView ?
                                               [{
                                                   required: true,
                                                   message: 'Please select billing proof status'
                                               }] : []}>
                                    <Radio.Group onChange={onBillingProofStatusChange} style={{marginTop: 4}}>
                                        <Radio value={RADIO_BUTTON_VALUES.YES}>Yes</Radio>
                                        <Radio value={RADIO_BUTTON_VALUES.NO}>No</Radio>
                                    </Radio.Group>
                                </Form.Item>
                                <Form.Item className='upload-form-item-radio-btn'
                                           label="Please Select the Billing Proof Type"
                                           name={"billingProofType"}
                                           style={{marginBottom: 12}}
                                           rules={!props.isFromSummaryView ?
                                               [{
                                                   required: true,
                                                   message: 'Please select billing proof type'
                                               }] : []}>
                                    <Radio.Group style={{marginTop: 4}}>
                                        <Radio value={RADIO_BUTTON_VALUES.UTILITY_BILL}>Utility Bill</Radio>
                                        {/*<Radio value={RADIO_BUTTON_VALUES.BANK_STATEMENT}>Bank Statement</Radio>*/}
                                    </Radio.Group>
                                </Form.Item>
                                <Alert style={{marginBottom: 10}} className='note-alert'
                                       description={
                                           <>
                                               <b>Note : </b>The billing proof document should be within 6 months of
                                               the period.
                                           </>
                                       }
                                       type="warning"
                                />
                                <Form.Item
                                    label="Billing Proof"
                                    name={"uploadUtilityBill"}
                                    getValueFromEvent={normFile}
                                    initialValue={utilityBillUploadedList && utilityBillUploadedList?.length > 0 ? [utilityBillUploadedList] : undefined}
                                    rules={[{required: true, message: 'Please upload your billing proof'}]}
                                >
                                    <Upload {...configs}
                                            className='upload_comp'
                                            accept={ALLOWED_IMAGE_TYPE_EXTENSION}
                                            listType="picture"
                                            onPreview={(e: any) => onPreview(e, DOCUMENT_TYPES.BP)}
                                            onRemove={(e: any) => onRemove("BP", DOCUMENT_TYPES.BP)}
                                            fileList={utilityBillUploadedList && utilityBillUploadedList?.length > 0 ? utilityBillUploadedList : undefined}
                                            beforeUpload={beforeUploadUtilityBill}>
                                        {(undefined != utilityBillUploadedList ? utilityBillUploadedList.length : [].length) < 1 &&
                                            <Button>
                                                <div className='upload-btn-div'>
                                                    <div className="upload-icon-div">
                                                        <PlusOutlined
                                                            style={{fontSize: 20, color: '#757575'}}/>
                                                    </div>
                                                    <div className="upload-btn-text-div">
                                                                <span>
                                                                    Upload the Billing Proof Document {ALLOWED_IMAGE_TYPES_TEXT}
                                                                </span>
                                                    </div>
                                                </div>
                                            </Button>
                                        }
                                    </Upload>
                                </Form.Item>
                                {/*   --- */}

                            </Col> : <></>

                        }


                        {billingProofStatus ?
                            <Col xxl={12} xl={12} lg={12} md={24} sm={24} xs={24} className={'margin_top_34'}>
                                <Form.Item
                                    style={{marginBottom: 0}}
                                    label={
                                        <>
                                                        <span className="additional-doc-title">
                                                            Additional Supporting Document
                                                        </span>
                                        </>
                                    }
                                >
                                    <Alert style={{marginBottom: 10}} className='note-alert'
                                           description={
                                               <>
                                                   <b>Note : </b>For documentation purposes, you may be required to
                                                   provide supporting documents such as a rent agreement, marriage
                                                   certificate, or birth certificate, among others.
                                               </>
                                           }
                                           type="warning"
                                    />
                                </Form.Item>
                                <Form.Item
                                    label=""
                                    name={"uploadAdditional"}
                                    getValueFromEvent={normFile}
                                    initialValue={additionalUploadedList && additionalUploadedList?.length > 0 ? [additionalUploadedList] : undefined}
                                    rules={[{
                                        required: true,
                                        message: 'Please upload your additional supporting document'
                                    }]}
                                >
                                    <Upload {...configs}
                                            className='upload_comp'
                                            listType="picture"
                                            accept={ALLOWED_IMAGE_TYPE_EXTENSION}
                                            onPreview={(e: any) => onPreview(e, DOCUMENT_TYPES.ASD)}
                                            onRemove={(e: any) => onRemove("ASD", DOCUMENT_TYPES.ASD)}
                                            fileList={additionalUploadedList && additionalUploadedList?.length > 0 ? additionalUploadedList : undefined}
                                            beforeUpload={beforeUploadASD}>
                                        {(undefined != additionalUploadedList ? additionalUploadedList.length : [].length) < 1 &&
                                            <Button>
                                                <div className='upload-btn-div'>
                                                    <div className="upload-icon-div">
                                                        <PlusOutlined
                                                            style={{fontSize: 20, color: '#757575'}}/>
                                                    </div>
                                                    <div className="upload-btn-text-div">
                                                                <span>
                                                                  Upload the Additional Supporting Document {ALLOWED_IMAGE_TYPES_TEXT}
                                                                </span>
                                                    </div>
                                                </div>
                                            </Button>
                                        }
                                    </Upload>
                                </Form.Item>
                            </Col> : <></>
                        }


                        <Col span={24}>
                            {/*{utilityBillUploadStatus ?*/}
                            <Form.Item
                                // name={"uploadBankConfirmation"}
                                style={{marginBottom: 4}}
                                label={
                                    <>
                                        <h4 className='account-create-form-subheader' style={{marginBottom: 0}}>Upload
                                            the Bank Confirmation Document</h4>
                                    </>
                                }
                                // rules={[{required: true, message: 'Please upload your bank confirmation document(s)'}]}
                            >
                                <Row gutter={[32, 8]}>
                                    <Col xxl={12} xl={12} lg={12} md={24} sm={24} xs={24}>
                                        <Form.Item
                                            label="Primary Bank Confirmation"
                                            name={"primaryBankUpload"}
                                            getValueFromEvent={normFile}
                                            initialValue={primaryBankUploadedList && primaryBankUploadedList?.length > 0 ? [primaryBankUploadedList] : undefined}
                                            rules={[{
                                                required: true,
                                                message: 'Please upload your primary bank confirmation document'
                                            }]}>
                                            <Upload {...configs}
                                                    className='upload_comp'
                                                    listType="picture"
                                                    accept={ALLOWED_IMAGE_TYPE_EXTENSION}
                                                    onPreview={(e: any) => onPreview(e, DOCUMENT_TYPES.PBCL)}
                                                    onRemove={(e: any) => onRemove("PBCL", DOCUMENT_TYPES.PBCL)}
                                                    fileList={primaryBankUploadedList && primaryBankUploadedList?.length > 0 ? primaryBankUploadedList : undefined}
                                                    beforeUpload={beforeUploadPBCD}>
                                                {(undefined != primaryBankUploadedList ? primaryBankUploadedList.length : [].length) < 1 &&
                                                    <Button>
                                                        <div className='upload-btn-div'>
                                                            <div className="upload-icon-div">
                                                                <PlusOutlined
                                                                    style={{fontSize: 20, color: '#757575'}}/>
                                                            </div>
                                                            <div className="upload-btn-text-div">
                                                                            <span>
                                                                                Upload the Primary Bank Confirmation Document {ALLOWED_IMAGE_TYPES_TEXT}
                                                                            </span>
                                                            </div>
                                                        </div>
                                                    </Button>
                                                }
                                            </Upload>

                                        </Form.Item>
                                    </Col>
                                    {secondaryBankStatus ?
                                        <Col xxl={12} xl={12} lg={12} md={24} sm={24} xs={24}>
                                            <Form.Item
                                                name={"secondaryBankUpload"}
                                                label="Secondary Bank Confirmation"
                                                getValueFromEvent={normFile}
                                                initialValue={secondaryBankUploadedList && secondaryBankUploadedList?.length > 0 ? [secondaryBankUploadedList] : undefined}
                                                rules={[{
                                                    required: true,
                                                    message: 'Please upload your secondary bank confirmation document'
                                                }]}>

                                                <Upload {...configs}
                                                        className='upload_comp'
                                                        accept={ALLOWED_IMAGE_TYPE_EXTENSION}
                                                        listType="picture"
                                                        onPreview={(e: any) => onPreview(e, DOCUMENT_TYPES.SBCL)}
                                                        onRemove={(e: any) => onRemove("SBCL", DOCUMENT_TYPES.SBCL)}
                                                        fileList={secondaryBankUploadedList && secondaryBankUploadedList?.length > 0 ? secondaryBankUploadedList : undefined}
                                                        beforeUpload={beforeUploadSBCD}>
                                                    {(undefined != secondaryBankUploadedList ? secondaryBankUploadedList.length : [].length) < 1 &&
                                                        <Button>
                                                            <div className='upload-btn-div'>
                                                                <div className="upload-icon-div">
                                                                    <PlusOutlined
                                                                        style={{
                                                                            fontSize: 20,
                                                                            color: '#757575'
                                                                        }}/>
                                                                </div>
                                                                <div className="upload-btn-text-div">
                                                                                <span>
                                                                                 Upload the Secondary Bank Confirmation Document {ALLOWED_IMAGE_TYPES_TEXT}
                                                                                </span>
                                                                </div>
                                                            </div>
                                                        </Button>
                                                    }
                                                </Upload>

                                            </Form.Item>
                                        </Col>
                                        : <></>}
                                </Row>
                            </Form.Item>
                            {/*: <></>}*/}
                        </Col>

                        <Col span={24}>
                            {greenCardHolderStatus ?
                                <Form.Item style={{marginBottom: 0}}
                                           label={
                                               <>
                                                   <h4 className='account-create-form-subheader'
                                                       style={{marginBottom: 0}}>Upload the W9 Form and FATCA
                                                       Declaration Form</h4>
                                               </>
                                           }
                                >
                                    <Row gutter={[32, 8]}>
                                        <Col xxl={12} xl={12} lg={12} md={24} sm={24} xs={24}>
                                            <Form.Item
                                                name={"w9Upload"}
                                                label="W9 Document"
                                                getValueFromEvent={normFile}
                                                initialValue={w9UploadedList && w9UploadedList?.length > 0 ? [w9UploadedList] : undefined}
                                                rules={[{
                                                    required: true,
                                                    message: 'Please upload the W9 form'
                                                }]}>

                                                <Upload {...configs}
                                                        className='upload_comp'
                                                        accept={ALLOWED_ALL_DOCUMENT_TYPE_EXTENSION}
                                                        listType="picture"
                                                        onPreview={(e: any) => onPreview(e, DOCUMENT_TYPES.W9)}
                                                        onRemove={(e: any) => onRemove("W9", DOCUMENT_TYPES.W9)}
                                                        fileList={w9UploadedList && w9UploadedList?.length > 0 ? w9UploadedList : undefined}
                                                        beforeUpload={beforeUploadW9}>
                                                    {(undefined != w9UploadedList ? w9UploadedList.length : [].length) < 1 &&
                                                        <Button>
                                                            <div className='upload-btn-div'>
                                                                <div className="upload-icon-div">
                                                                    <PlusOutlined
                                                                        style={{fontSize: 20, color: '#757575'}}/>
                                                                </div>
                                                                <div className="upload-btn-text-div">
                                                                        <span>
                                                                          Upload the W9 Document {ALLOWED_ALL_TYPES_TEXT}
                                                                        </span>
                                                                </div>
                                                            </div>
                                                        </Button>
                                                    }
                                                </Upload>

                                            </Form.Item>
                                        </Col>
                                        <Col xxl={12} xl={12} lg={12} md={24} sm={24} xs={24}>
                                            <Form.Item
                                                name={"fatcaUpload"}
                                                label="FATCA Declaration Form"
                                                getValueFromEvent={normFile}
                                                initialValue={fatcaUploadedList && fatcaUploadedList?.length > 0 ? [fatcaUploadedList] : undefined}
                                                rules={[{
                                                    required: true,
                                                    message: 'Please upload the FATCA declaration form'
                                                }]}>

                                                <Upload {...configs}
                                                        className='upload_comp'
                                                        listType="picture"
                                                        accept={ALLOWED_ALL_DOCUMENT_TYPE_EXTENSION}
                                                        onPreview={(e: any) => onPreview(e, DOCUMENT_TYPES.FATCA_FORM)}
                                                        onRemove={(e: any) => onRemove("FACT", DOCUMENT_TYPES.FATCA_FORM)}
                                                        fileList={fatcaUploadedList && fatcaUploadedList?.length > 0 ? fatcaUploadedList : undefined}
                                                        beforeUpload={beforeUploadFATCA}>
                                                    {(undefined != fatcaUploadedList ? fatcaUploadedList.length : [].length) < 1 &&
                                                        <Button>
                                                            <div className='upload-btn-div'>
                                                                <div className="upload-icon-div">
                                                                    <PlusOutlined
                                                                        style={{fontSize: 20, color: '#757575'}}/>
                                                                </div>
                                                                <div className="upload-btn-text-div">
                                                                        <span>
                                                                            Upload the FATCA Declaration Document {ALLOWED_ALL_TYPES_TEXT}
                                                                        </span>
                                                                </div>
                                                            </div>
                                                        </Button>
                                                    }
                                                </Upload>

                                            </Form.Item>
                                        </Col>
                                    </Row>
                                </Form.Item> : <></>
                            }
                        </Col>

                        <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                            <Row>
                                <Col span={24}>
                                    <Form.Item
                                        label={
                                            <>
                                                <h4 className='account-create-form-subheader'
                                                    style={{marginBottom: 0}}>Upload Your Profile Picture
                                                    (Optional)</h4>
                                            </>
                                        }
                                    >
                                        <Form.Item
                                            name={"uploadProfilePic"}
                                            label="">
                                            <Upload {...configs}
                                                    className='upload_comp'
                                                    listType="picture"
                                                    accept={ALLOWED_IMAGE_TYPE_EXTENSION}
                                                    onPreview={(e: any) => onPreview(e, DOCUMENT_TYPES.PROPIC)}
                                                    fileList={profilePicUploadedList && profilePicUploadedList?.length > 0 ? profilePicUploadedList : undefined}
                                                    onRemove={(e: any) => onRemove("PROPIC", DOCUMENT_TYPES.PROPIC)}
                                                    beforeUpload={beforeUploadPP}>
                                                {(undefined != profilePicUploadedList ? profilePicUploadedList.length : [].length) < 1 &&
                                                    <Button>
                                                        <div className='upload-btn-div'>
                                                            <div className="upload-icon-div">
                                                                <PlusOutlined
                                                                    style={{fontSize: 20, color: '#757575'}}/>
                                                            </div>
                                                            <div className="upload-btn-text-div">
                                                            <span>
                                                                Upload the Profile Picture {ALLOWED_IMAGE_TYPES_TEXT}
                                                            </span>
                                                            </div>
                                                        </div>
                                                    </Button>
                                                }
                                            </Upload>
                                        </Form.Item>
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    {
                        !props.isFromSummaryView ?
                            <>
                                <Row>
                                    <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                        <Divider></Divider>
                                    </Col>
                                </Row>
                                <Space style={{float: 'right'}} className='form_next_btn_col'>
                                    <Form.Item>
                                        <Button className='form_next_btn' htmlType="submit" type="primary">
                                            Next
                                        </Button>
                                    </Form.Item>
                                </Space>
                            </> : ''
                    }

                </Form>

            </div>
        </Spin>
    )

}
export default AttachmentAndSupportingDetail;

